import React, { useEffect, useState } from "react";
import * as MUIStyled from "../../../MUIStyled";
import * as Styled from "../../../CompanyForm.styled";
import { DefaultLayout } from "../../common/Layout/DefaultLayout.js";
import Confetti from "react-confetti";

export const ThankyouPage = () => {
    const storedUUID = sessionStorage.getItem("storedUUID"); // Delete it later
    // State for window size to adjust confetti canvas
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    // Adjust window size when resized
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            setWindowHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // Delete it later
    // get storedUUID from sessionStorage and create a new key for usedUUID on localStorage
    useEffect(() => {
        if (storedUUID) {
            localStorage.setItem("usedUUID", storedUUID);
            sessionStorage.removeItem("storedUUID");
        }
    }, [storedUUID]);

    return (
        <DefaultLayout
            hideContinueButton={true}
            isThankYouPage={true}>
            <MUIStyled.ThankyouWrapper>
                <Confetti
                    width={windowWidth}
                    height={windowHeight}
                    numberOfPieces={200}
                    gravity={0.3}
                    colors={["#ff0", "#f0f", "#0ff"]} // Customize colors
                />

                <Styled.MainTitle style={{ margin: "40px 0 20px 0" }}>
                    Thank you for submitting this form.
                </Styled.MainTitle>
                <Styled.ThankyouCopy>
                    If you have any questions, you can reach our team on{" "}
                    <a href="mailto:employersupport@nla.com.au">
                        employersupport@nla.com.au
                    </a>{" "}
                    or by calling <a href="tel:1300665112">1300 665 112</a>.
                </Styled.ThankyouCopy>
            </MUIStyled.ThankyouWrapper>
        </DefaultLayout>
    );
};
